import Http from '@/utils/http'
const baseUrl = '/app/teacher'

/**
 *章节列表
 * @param params
 * 
*/

export const chapterList = params => Http.get(`${baseUrl}/chapter`, { params })


/**
 *章节详情
 * @param classChapterId
 * 
*/

export const chapterInfo = classChapterId => Http.get(`${baseUrl}/chapter/${classChapterId}` )

/**
 *修改章节
 * @param params
 * 
*/

export const editChapter = params => Http.put(`${baseUrl}/chapter/`, params )

/**
 *章节ppt
 * @param classChapterId
 * 
*/

export const chapterPPT = classChapterId => Http.get(`${baseUrl}/chapter/${classChapterId}/ppt` )

/**
 *章节ppt新增锚点
 * @param params
 * 
*/

export const addAnchor = params => Http.put(`${baseUrl}/chapter/ppt/${params.imageId}/anchor/point`, params.list )

/**
 *章节测验
 * @param classChapterId
 * 
*/

export const chapterTest = classChapterId => Http.get(`${baseUrl}/chapter/${classChapterId}/test` )

/**
 *开始上课
 * @param classChapterId
 * 
*/

export const startClass = classChapterId => Http.put(`${baseUrl}/chapter/${classChapterId}/start` )

/**
 *修改锁定
 * @param params
 * 
*/

export const editLock = params => Http.put(`${baseUrl}/chapter`, params )

/**
 *学生列表
 * @param classChapterId
 * 
*/

export const studentList = classChapterId => Http.get(`${baseUrl}/class/user/quality/${classChapterId}`)

/**
 *评价详情
 * @param params
 * 
*/

export const appraiseDetail = params => Http.get(`${baseUrl}/class/user/quality/${params.classChapterId}/${params.userId}`)

/**
 *保存评价
 * @param params
 * 
*/

export const saveAppraise = params => Http.post(`${baseUrl}/class/user/quality`, params)

/**
 *完成素养评价
 * @param classChapterId
 * 
*/

export const completeAppraise = classChapterId => Http.put(`${baseUrl}/class/user/quality/${classChapterId}/complete`)

/**
 *结算分数
 * @param classChapterId
 * 
*/

export const settlement = classChapterId => Http.put(`${baseUrl}/chapter/${classChapterId}/complete`)

/**
 *学情统计
 * @param classChapterId
 * 
*/

export const chapterStatistics = classChapterId => Http.get(`${baseUrl}/statistics/xq/${classChapterId}`)

/**
 *学情统计详情
 * @param params
 * 
*/

export const chapterStatisticsDetail = params => Http.get(`${baseUrl}/statistics/xq/${params.classChapterId}/${params.type}`, { params } )
